export const pieChartColours = [
  "rgba(255, 99, 132, 0.5)",
  "rgba(53, 162, 235, 0.5)",
  "rgba(53, 50, 170, 0.5)",
  "rgba(53, 162, 100, 0.5)",
  "rgba(250, 162, 235, 0.5)",
  "rgba(150, 100, 235, 0.5)",
  "rgba(250, 162, 50, 0.5)",
  "rgba(50, 50, 50, 0.5)",
  "rgba(250, 100, 100, 0.5)",
  "rgba(100, 250, 100, 0.5)",
  "rgba(100, 100, 250, 0.5)",
  "rgba(1, 250, 250, 0.5)",
];

export default {
  pieChartColours,
};
